<template>
  <main>
    <section>
      <h4>Introdução</h4>
      <p class="text-justify">
        Um universo que se passa na era moderna e na nossa terra, mas que une
        alguns elementos medievais e fantásticos que se misturam no mundo atual.
        Esse universo é habitado apenas por humanos.
      </p>
    </section>
    <hr />

    <section>
      <h4>História Principal</h4>
      <p class="text-justify">
        <strong>Ban</strong> veio de uma família de policiais, mas além disso,
        sua família também passava alguns ensinamentos que vinham de geração em
        geração. Uma tradição, onde todos os filhos homem deviam ser preparados
        para o combate com espadas. No início <strong>Ban</strong> achou isso um
        absurdo, pois de que adianta uma espada em um mundo com armas de fogo
        tão poderosas e letais. Mas quando começou seu treinamento quando
        criança percebeu que não era apenas manusear uma espada. Eram técnicas
        que ele nunca tinha visto antes. Ficou fascinado com tudo aquilo e se
        empenhou muito a aperfeiçoar suas habilidades com a espada. Quando
        completou 16 anos, ganhou a espada de seu pai, que era também passada de
        geração em geração, mas parecia que nunca havia sido usada, pela sua
        tamanha beleza.
      </p>

      <p class="text-justify">
        Os anos se passaram e <strong>Ban</strong> aperfeiçoou ainda mais suas
        habilidades, mas não quis seguir a carreira como policial, preferia
        trabalhar sozinho e se tornou um detetive particular. Ele queria
        descobrir se havia mais pessoas que como ele, herdaram "habilidades" de
        luta e aproveitava de sua profissão para investigar sobre isso. Um de
        seus clientes, um poderoso homem de negócios, o contratou para
        investigar sobre uma suposta organização secreta que estava atrapalhando
        seus negócios. <strong>Ban</strong> conseguiu rastrear depois de alguns
        dias alguns membros dessa suposta organização e conseguiu uma ligação
        entre esse grupo e um advogado, que ele foi visitar no final do dia.
        Chegando lá ele se surpreendeu com o advogado, era um homem alto e muito
        musculoso chamado <strong>Shikijo</strong>.
        <strong>Ban</strong> desconfiou que <strong>Shikijo</strong> poderia não
        ser um advogado de verdade e depois de algumas horas conversando e
        tentando tirar alguma informação dele, <strong>Shikijo</strong> ataca
        <strong>Ban</strong> e a luta dos dois destrói quase que por completo o
        local. <strong>Ban</strong> sempre andava com sua espada escondida e
        como ele imaginava, <strong>Shikijo</strong> não era um simples advogado
        e possuía habilidades de combate que não eram comuns, assim como as
        dele. <strong>Ban</strong> consegue derrotar <strong>Shikijo</strong> e
        depois da luta terminada, eles voltam a conversar e acabam descobrindo
        que ambos estão em busca da mesma organização e que tinham pensado que o
        outro seria dessa organização. Eles decidem se unir para investigar
        sobre essa organização.
      </p>

      <p class="text-justify">
        Depois de mais alguns dias, <strong>Ban</strong> e
        <strong>Shikijo</strong> rastreiam um encontro entre dois supostos
        membros da organização. Eles ficam espiando de longe a conversa que
        acontecia no porto da cidade. As pessoas eram uma mulher bastante
        conhecida na cidade por ser uma empresária jovem e famosa,
        <strong>Ann</strong>, e o outro era um homem que
        <strong>Ban</strong> conhecia de uma academia de luta que frequentou por
        um tempo. Esse homem era conhecido apenas como <strong>Slash</strong> e
        ele dizia que o apelido era pelas suas habilidades com espadas, mas
        <strong>Ban</strong> nunca acreditou, pois ele era alguém que gostava
        muito de se exaltar e um exemplo clássico de narcisista.
      </p>

      <p class="text-justify">
        Em um certo momento, <strong>Shikijo</strong> fez um barulho que alertou
        <strong>Ann</strong> e <strong>Slash</strong>. Eles foram em busca da
        origem do barulho e acabaram encontrando <strong>Ban</strong> e
        <strong>Shikijo</strong> e entraram em combate. A luta estava
        equilibrada, mas <strong>Ann</strong> alerta <strong>Slash</strong> que
        o líder deles não iria gostar daquilo e resolveram fugir.
        <strong>Ban</strong> e <strong>Shikijo</strong> tentaram seguir, mas
        falharam. Agora seja quem for a organização pela qual eles trabalham, já
        sabem quem são <strong>Ban</strong> e <strong>Shikijo</strong> e sabem
        que estão atrás deles.
      </p>
    </section>
    <hr />

    <characters-list :universe="universe" />
  </main>
</template>

<script>
import CharactersList from '../CharactersList'

export default {
  name: 'samurais-seculo-xxi',

  props: {
    universe: { type: Object, required: true },
  },

  components: { CharactersList },
}
</script>
